import type { ComponentProps } from 'react';

import { cn } from '../cn';

const HEADER_CLASSES = cn(
  'flex items-center gap-3 px-6 py-3 text-xs transition-colors font-semibold',
  'bg-slate-200 text-slate-700 dark:bg-slate-900 dark:text-slate-100',
  'sticky top-0 z-50',
);

const CLICKABLE_CLASSES = 'cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-800';

export default function TableCellHeader({ children, className, onClick, ...props }: ComponentProps<'div'>) {
  return (
    <div className={cn(HEADER_CLASSES, onClick && CLICKABLE_CLASSES, className)} onClick={onClick} {...props}>
      {children}
    </div>
  );
}
